export const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  const limited = digits.slice(0, 10);

  if (limited.length === 0) return "";
  if (limited.length <= 3) return `(${limited}`;
  if (limited.length <= 6) return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
};

export const parsePhoneValue = (formattedValue: string): string => formattedValue.replace(/\D/g, "");
